import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import { useContext } from "react";
import { UpgradeModalContext } from "@zapier/upsells/esm/contexts";
const API_IMAGES = {
    AppTesterAPI: "https://cdn.zapier.com/storage/services/4401a6c0fdab0b69893ab957f2712b81.png",
    BranchingAPI: "https://cdn.zapier.com/storage/services/137baf61724ea2c64812417382bddd1d.128x128.png",
    EventbriteAPI: "https://cdn.zapier.com/storage/photos/4b2b5f32f92c80fc304ab369be1da347.png",
    EventbriteDevAPI: "https://cdn.zapier.com/storage/developer/638ebef07f1e312e20ee45ddb7df6be5.png",
    GoogleContactsV2API: "https://cdn.zapier.com/storage/services/1508661b55cd3c5ad1787303b0f58c99.png",
    GoogleFormsAPI: "https://cdn.zapier.com/storage/services/2554f3f9544cf8375a46f68b18de0e7d.128x128.png",
    GoogleSheetsAPI: "https://cdn.zapier.com/storage/services/e37713ab22d82f777575279db97cd805.128x128.png",
    LegacyZapierAPI: "https://cdn.zapier.com/storage/photos/1a30986746a7918f9ab1e20ec13bc6e7.png",
    MailChimpAPI: "https://cdn.zapier.com/storage/services/5c727288d9c2f69a9eee136c5f5a0f72.128x128.png",
    OneNoteDevAPI: "https://cdn.zapier.com/storage/developer/e951e0105790e43b117e04b7bba34601.png",
    PivotalTrackerAPI: "https://cdn.zapier.com/storage/services/84172dde558de382873cf72a00c92818.128x128.png",
    SkyDriveAPI: "https://cdn.zapier.com/storage/services/e67867e9f6f5c089e243dad54467ad33.128x128.png",
    SurveyMonkeyAPI: "https://cdn.zapier.com/storage/services/39b027caffb7fad05f73ed80d664a246.128x128.png",
    TypeformDevAPI: "https://cdn.zapier.com/storage/developer/6df0e2a9ca7350c7407f0d9c2b0709c0.png",
    ZapierAPI: "https://cdn.zapier.com/storage/photos/ec33e6d4fa3c24c2f7822e176cdc4406.png",
    ZapierInternalAPI: "https://cdn.zapier.com/storage/photos/ff7409c6a52dc217fe9829531c3a66dd.png",
};
const stripVersion = (name) => { var _a; return ((_a = name === null || name === void 0 ? void 0 : name.split("@")) === null || _a === void 0 ? void 0 : _a[0]) || ""; };
export const LogoImage = ({ app }) => {
    var _a;
    const { appLogoUrl } = useContext(UpgradeModalContext);
    if (!app) {
        app = "ZapierAPI";
    }
    const appUnversioned = stripVersion(app);
    const imageSize = 40;
    const backgroundImageUrl = appLogoUrl
        ? appLogoUrl
        :
            (_a = API_IMAGES[appUnversioned]) !== null && _a !== void 0 ? _a : API_IMAGES.ZapierAPI;
    const styles = css({
        backgroundImage: `url('${backgroundImageUrl}')`,
        backgroundSize: `${imageSize}px ${imageSize}px`,
        height: imageSize,
        position: "absolute",
        right: 32,
        top: "50%",
        transform: "translateY(calc(-50% + 5px))",
        width: imageSize,
    });
    return _jsx("div", { css: styles });
};

// @zapier/upsells@8.0.1 (466b4077f)
